






















































import { Component, Vue } from "vue-property-decorator";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import { settingStorageApi } from "@/getinfo-api";
import { getCurrentCompanyId } from "@/plugins/roles";
import { Setting as ISetting } from "@/api-v2/settings-storage/models";
import EditorWithFile from "@/components/EditorWithFile.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { informationModule } from "@/plugins/modules-detect";
import Error from "@/views/errors/Error.vue";
@Component({
  components: { Error, CustomButton, EditorWithFile, CBlock }
})
export default class EducationalOrganization extends Vue {
  isLoading: boolean = false;
  body: any = "";
  showEditorWithFiles: boolean = false;

  form: ISetting = {
    name: "educationOrganization",
    value: {
      info: [
        {
          title: `${this.$tc(this.$translate.BasicInformation)}`,
          value: ``
        },
        {
          title: `${this.$tc(this.$translate.StructureAndManagementBodies)}`,
          value: ``
        },
        {
          title: `${this.$tc(this.$translate.Documents)}`,
          value: ``
        },
        {
          title: `${this.$tc(this.$translate.Education)}`,
          value: ``
        },
        {
          title: `${this.$tc(this.$translate.EducationalStandards)}`,
          value: ``
        },
        {
          title: `${this.$tc(this.$translate.ManagementPedagogicalStaff)}`,
          value: ``
        },
        {
          title: `${this.$tc(
            this.$translate
              .MaterialAndTechnicalSupportAndEquipmentOfTheEducationalProcess
          )}`,
          value: ``
        },
        {
          title: `${this.$tc(
            this.$translate.ScholarshipsAndOtherTypesOfMaterialSupport
          )}`,
          value: ``
        },
        {
          title: `${this.$tc(this.$translate.PaidEducationalServices)}`,
          value: ``
        },
        {
          title: `${this.$tc(this.$translate.FinancialAndEconomicActivities)}`,
          value: ``
        },
        {
          title: `${this.$tc(this.$translate.VacantPlacesForAdmission)}`,
          value: ``
        },
        {
          title: `${this.$tc(this.$translate.AccessibleEnvironment)}`,
          value: ``
        },
        {
          title: `${this.$tc(this.$translate.InternationalCooperation)}`,
          value: ``
        }
      ]
    }
  };

  get isInformationModule() {
    return informationModule();
  }

  get companyId() {
    return getCurrentCompanyId();
  }

  showEditor() {
    this.showEditorWithFiles = !this.showEditorWithFiles;
    if (this.showEditorWithFiles) {
      this.scrollToEdit();
    }
  }

  async putCompanySettings() {
    if (this.companyId) {
      try {
        this.isLoading = true;
        await settingStorageApi.Company.putCompanySettings(this.companyId, [
          this.form
        ]);
        await this.$store.dispatch("successToast", {
          message: `${this.$tc(this.$translate.Successful)}`
        });
      } finally {
        this.isLoading = false;
        await this.getCompanySettings();
      }
      this.showEditorWithFiles = false;
    }
  }

  scrollToEdit() {
    window.scrollTo({
      top: 1000,
      behavior: "smooth"
    });
  }

  async getCompanySettings() {
    try {
      this.isLoading = true;
      const { data } = await settingStorageApi.Company.getCompanySettings(
        this.companyId,
        ["educationOrganization"]
      );
      if (data[0]) {
        this.form = data[0];
      }
    } finally {
      this.isLoading = false;
    }
  }

  mounted() {
    this.getCompanySettings();
  }
}
